import { Route } from 'react-router';
import React, { lazy } from 'react';
import routes from '../routes';
const LogoutScreen = lazy(() => import('../../screens/Auth/screens/Logout'));

const authRoutes = [<Route exact key={routes.LOGOUT} path={routes.LOGOUT} component={LogoutScreen} />];

export default authRoutes;
